export enum operationTypeEnum {
  PURCHASE_WITHDRAWAL = "purchase_withdrawal",
  PONTUATION = "pontuation"
}
